import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IRoute, routes, UIViewCategory, UIViewSubCategory } from "../../routes/routes";
import NavigationDataService from "../../services/navigation-data-service/NavigationDataService";

const NavigationViewListUtils = {

    getData: async function (customerID: number,
        contextGroupID: number,
        eLynxObject: IeLynxObject,
        offline: boolean): Promise<IRoute[]> {

        const availableViews = await NavigationDataService.getAvailableViews(customerID, contextGroupID, eLynxObject, offline);

        if (eLynxObject.objectType === eLynxObjectTypeEnum.Group) {
            availableViews.push(UIViewEnum.Playground);
        }

        return availableViews.reduce((result: IRoute[], currentValue) => {
            return result.concat(routes.filter(o => o.viewID === currentValue))
        }, []);

    },

    getSubcategoryLabel: function (subCategory: UIViewSubCategory): string {

        switch (subCategory) {
            case UIViewSubCategory.GroupVisualizations:
                return "Group Visualizations";

            case UIViewSubCategory.GroupDataEntry:
                return "Group Data Entry";

            case UIViewSubCategory.GroupReporting:
                return "Reporting";

            case UIViewSubCategory.DeviceVisualizations:
                return "Device Visualizations";

            case UIViewSubCategory.DeviceDataEntry:
                return "Device Data Entry";

            case UIViewSubCategory.DeviceReporting:
                return "Device Reporting";

            case UIViewSubCategory.WellVisualization:
                return "Well Visualizations";

            case UIViewSubCategory.WellDataEntry:
                return "Well Data Entry";

            case UIViewSubCategory.WellReporting:
                return "Well Reporting";

            case UIViewSubCategory.TankBatteryVisualization:
                return "Tank Battery Visualizations";

            case UIViewSubCategory.TankBatteryDataEntry:
                return "Tank Battery Data Entry";

            case UIViewSubCategory.TankVisualization:
                return "Tank Visualizations";

            case UIViewSubCategory.TankDataEntry:
                return "Tank Data Entry";

            case UIViewSubCategory.TankReporting:
                return "Tank Reporting";

            case UIViewSubCategory.TagVisualization:
                return "Tag Visualizations";

            case UIViewSubCategory.TagDataEntry:
                return "Tag Data Entry";

            case UIViewSubCategory.TagReporting:
                return "Tag Reporting";

            case UIViewSubCategory.Uncategorized:
                return "Miscellaneous";

            default:
                return "";
        }

    },

    getCategoryLabel: function (category: UIViewCategory): string {

        switch (category) {
            case UIViewCategory.Group:
                return "Group";

            case UIViewCategory.TankBattery:
                return "Tank Battery";

            case UIViewCategory.Device:
                return "Device";

            case UIViewCategory.Well:
                return "Well";

            case UIViewCategory.Tank:
                return "Tank";

            case UIViewCategory.Tag:
                return "Tag";

            default:
                return "";
        }
    },

    getCategoryDefaultOrder: function (category: UIViewCategory): number {
        const uiViewCategoryOrder: Record<UIViewCategory, number> = {
            [UIViewCategory.Group]: 0,
            [UIViewCategory.Device]: 1,
            [UIViewCategory.Well]: 2,
            [UIViewCategory.TankBattery]: 3,
            [UIViewCategory.Tank]: 4,
            [UIViewCategory.Tag]: 5,
            [UIViewCategory.AdminGroup]: 6,
            [UIViewCategory.AdminView]: 7
        };

        return uiViewCategoryOrder[category];
    },

    getSubcategoryDefaultOrder: function (subCategory: UIViewSubCategory): number {
        const uiViewSubCategoryOrder: Record<UIViewSubCategory, number> = {
            [UIViewSubCategory.GroupVisualizations]: 0,
            [UIViewSubCategory.GroupDataEntry]: 1,
            [UIViewSubCategory.GroupReporting]: 2,
            [UIViewSubCategory.DeviceVisualizations]: 0,
            [UIViewSubCategory.DeviceDataEntry]: 1,
            [UIViewSubCategory.DeviceReporting]: 2,
            [UIViewSubCategory.WellVisualization]: 0,
            [UIViewSubCategory.WellDataEntry]: 1,
            [UIViewSubCategory.WellReporting]: 2,
            [UIViewSubCategory.TankBatteryVisualization]: 0,
            [UIViewSubCategory.TankBatteryDataEntry]: 1,
            [UIViewSubCategory.TankBatteryReporting]: 2,
            [UIViewSubCategory.TankVisualization]: 0,
            [UIViewSubCategory.TankDataEntry]: 1,
            [UIViewSubCategory.TankReporting]: 2,
            [UIViewSubCategory.TagVisualization]: 0,
            [UIViewSubCategory.TagDataEntry]: 1,
            [UIViewSubCategory.TagReporting]: 2,
            [UIViewSubCategory.Uncategorized]: 99
        };

        return uiViewSubCategoryOrder[subCategory];
    }

};

export default NavigationViewListUtils;
